import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FinanceAPInvoiceActivity extends Component {

    constructor(props){
        super(props)
        this.RenderedComponent = import("app/components/Accounting/Invoice/InvoiceSimple")
    }

    render() {
        return (
            <Activity 
                name="FinanceARInvoice"
                RenderedComponent={this.RenderedComponent}
                context="FinanceARInvoice"
            />
        )
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(FinanceAPInvoiceActivity)
